import CalendarSharingError from '../store/schema/CalendarSharingError';
import findSharingPermissionByEmail from '../utils/findSharingPermissionByEmail';
import getSharingPermissionListToSearch from '../utils/getSharingPermissionListToSearch';
import getStore from '../store/sharingStore';
import SharingPermissionItemState from '../store/schema/SharingPermissionItemState';
import { mutator } from 'satcheljs';
import { setSharingPermissionError } from '../actions/calendarSharing';

export default mutator(setSharingPermissionError, msg => {
    let viewState = getStore().viewState;
    let sharingPermissionItem = msg.sharingPermission;
    let errorStatus: CalendarSharingError = msg.errorStatus;

    if (!viewState || !sharingPermissionItem) {
        return;
    }

    let filteredPermissions: SharingPermissionItemState[] = findSharingPermissionByEmail(
        getSharingPermissionListToSearch(sharingPermissionItem, viewState),
        sharingPermissionItem
    );

    if (filteredPermissions && filteredPermissions.length) {
        filteredPermissions[0].errorStatus = errorStatus;
    }
});
